import React from 'react';
import { useHistory } from 'react-router-dom';
import { Layout, Modal } from 'antd';
import styled from 'styled-components';
import FullScreenButton from 'src/components/common/FullScreenButton';

const { Header: HeaderWrapper } = Layout;

const HeaderBar = styled(HeaderWrapper)`
  height: 77px;
  line-height: 77px;
  padding: 0 24px;
  background: linear-gradient(180deg, #2755b9, #2347a6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);

  @media (max-width: 1100px), (max-height: 720px) {
    height: 62px;
    line-height: 62px;
    padding: 0 18px;
  }

  @media (max-width: 900px), (max-height: 620px) {
    height: 54px;
    line-height: 54px;
    padding: 0 14px;
  }
`;

const LeftGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  @media (max-width: 1100px), (max-height: 720px) {
    gap: 9px;
  }
`;

const MenuButton = styled.button`
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  position: relative;

  @media (max-width: 1100px), (max-height: 720px) {
    width: 28px;
    height: 28px;
  }
`;

const MenuIcon = styled.span`
  position: absolute;
  top: 15px;
  left: 3px;
  width: 26px;
  height: 3px;
  background: #fff;
  box-shadow: 0 -7px 0 #fff, 0 7px 0 #fff;

  @media (max-width: 1100px), (max-height: 720px) {
    top: 13px;
    width: 23px;
    height: 2px;
    box-shadow: 0 -6px 0 #fff, 0 6px 0 #fff;
  }
`;

const Logo = styled.img`
  display: block;
  height: 42px;
  width: auto;

  @media (max-width: 1100px), (max-height: 720px) {
    height: 34px;
  }

  @media (max-width: 900px), (max-height: 620px) {
    height: 30px;
  }
`;

const RightGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  color: #fff;

  @media (max-width: 1100px), (max-height: 720px) {
    gap: 13px;
  }
`;

const UserText = styled.span`
  font-size: 24px;
  font-weight: 700;
  line-height: 1;

  @media (max-width: 1100px), (max-height: 720px) {
    font-size: 21px;
  }

  @media (max-width: 900px), (max-height: 620px) {
    font-size: 18px;
  }
`;

const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  color: #fff;
  font-size: 32px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
  background-image: url('/images/ddsc/exit.png');
  background-size: contain;
  background-repeat: no-repeat;
  width: 32px;
  height: 32px;

  @media (max-width: 1100px), (max-height: 720px) {
    width: 28px;
    height: 28px;
  }

  @media (max-width: 900px), (max-height: 620px) {
    width: 24px;
    height: 24px;
  }
`;

const FullscreenIcon = styled.div`
  width: 32px;
  height: 32px;
  cursor: pointer;
  background-image: url(${({ $src }) => $src});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  filter: brightness(0) invert(1);

  @media (max-width: 1100px), (max-height: 720px) {
    width: 28px;
    height: 28px;
  }

  @media (max-width: 900px), (max-height: 620px) {
    width: 24px;
    height: 24px;
  }
`;

function DDSCHeader() {
  const history = useHistory();

  const handleCloseClick = () => {
    Modal.confirm({
      icon: null,
      title: 'Exit',
      content: '학습을 종료하시겠습니까?',
      onOk: () => history.push('/'),
    });
  };

  return (
    <HeaderBar>
      <LeftGroup>
        <MenuButton type="button" aria-label="menu">
          <MenuIcon />
        </MenuButton>

        <Logo src="/images/ddsc/logo.png" alt="똑똑과학" />
      </LeftGroup>

      <RightGroup>
        <UserText>fools1004@</UserText>
        <FullScreenButton
          element={<FullscreenIcon $src="/images/fullscreen.png" role="button" aria-label="fullscreen" />}
          activeElement={<FullscreenIcon $src="/images/fullscreenExit.png" role="button" aria-label="exit fullscreen" />}
        />
        <CloseButton type="button" aria-label="close" onClick={handleCloseClick} />
      </RightGroup>
    </HeaderBar>
  );
}

export default DDSCHeader;
